(ns kyber.components.composite.passwordless-sign-in
  (:require [re-frame.core :as re-frame]

            [kyber.components.base.button :as button]
            [kyber.components.base.text :as text]
            [kyber.components.base.link :as link]
            [kyber.components.composite.gdpr-splash :as gdpr-splash]
            [kyber.components.forms.passwordless-sign-in
             :as forms.passwordless-sign-in]

            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.i18n.core :as i18n]))

(defn- context->label [context]
  (if (get #{"activity" "curriculum"} context)
    {:pre (i18n/t* ::access-this context)
     :post (i18n/t* ::give-access context)}
    {:pre (i18n/t* ::sign-in)
     :post (i18n/t* ::sign-you-in)}))

(def classes
  (styles->classes
   {:submitted
    {"& button"
     {:display :inline-block}}

    :left-align
    {:text-align :left}

    :center-align
    {:display         "flex"
     :justify-content "center"
     :margin-top      (gs [:spacing :p16])
     :margin-bottom   (gs [:spacing :p16])}

    :dark-background
    {"& .reagent-form-field-label,
      & p:not(.reagent-form-field-error):not(.reagent-form-errors)"
     {:color :white}}

    :light-background
    {"& .reagent-form-field-label,
      & p:not (.reagent-form-field-error):not(.reagent-form-errors)"
     {:color (gs [:colors :gray-scale-600])}}

    :submitted-message
    {:display :block
     :margin  [(gs [:spacing :p20])
              (gs [:spacing :p0])]
     "& > span"
     {:display :block}}}))

(defn- form-submitted [email labels]
  [:div {:class (:submitted classes)}
   [text/title-30 :p (i18n/t* ::check-email)]
   [text/body-30 :p
    [:span {:class (:submitted-message classes)}
     [:span (i18n/t* ::sent-to email)]
     [:span (i18n/t* ::has-link (:post labels))]]]
   [text/body-20 :p {}
    [:span (i18n/t* ::wrong-email)
     [button/button-link
      {:on-click #(re-frame/dispatch
                   [:authentication/passwordless-sign-in-reset])}
      (i18n/t* ::different-button)]]]
   [text/body-20 :p {}
    [:span (i18n/t* ::no-email)
     [button/button-link
      {:on-click #(re-frame/dispatch [:authentication/passwordless-sign-in
                                      {:email email}])}
      (i18n/t* ::resend-button)]]]])

(defn render
  "`activity-uuid` and `is-learner?` are optional as part of disabling passwordless sign in"
  [{:keys [query-params context theme activity-uuid is-learner?]}]
  (let [{:strs [error email]} query-params
        link-expired?         (= error "expired-sign-in-link")

        passwordless-sign-in-email
        @(re-frame/subscribe [:authentication/passwordless-sign-in-email])
        idp-integrations
        @(re-frame/subscribe [:authentication.activity/idp-integrations
                              {:activity/uuid activity-uuid}])

        ;; 2023-07-10 Justin - This is a _quick solution_ to disable passwordless sign in
        ;; It assumes there is only one idp-integration per activity
        ;; Because of that assumption it acts on the first idp that has the disabled attribute set to true
        ;; It also assumes users do not access via CLP
        {homepage-url                 :activity.idp-integration/homepage-url
         disable-passwordless-sign-in :activity.idp-integration/disable-passwordless-sign-in}
        (->> idp-integrations
             (some
              (fn [{disable? :activity.idp-integration/disable-passwordless-sign-in
                   :as      idp-integration}]
                (when disable? idp-integration))))


        labels (context->label context)]
    [:div {:class (get classes theme)}
     (if (and disable-passwordless-sign-in
              is-learner?
              (= context "activity")
              (some? homepage-url))
       [:<>
        [text/body-30 :p {}
         [:span (i18n/t* ::oops-wrong-place)]]

        [:div {:class (:center-align classes) }
         [link/primary-anchor-button {:href homepage-url}
          (i18n/t* ::access-education)]]

        [gdpr-splash/render
         (when (= :light-background theme)
           {:color (gs [:colors :gray-scale-600])})]]

       (if (some? passwordless-sign-in-email)
         [form-submitted passwordless-sign-in-email labels]
         [:<>
          [text/body-30 :p {}
           [:span
            [:span {:style {:font-weight (gs [:font-weight :title-30])}}
             (when link-expired? (i18n/t* ::link-expired))]
            (i18n/t* ::enter-email-to (:pre labels))]]
          [:div {:class (:left-align classes)}
           [forms.passwordless-sign-in/render {:email email}]]
          [gdpr-splash/render
           (when (= :light-background theme)
             {:color (gs [:colors :gray-scale-600])})]]))]))
